export default function initThankYouCalendar() {
    $('.thank-you-add-to-calendar').on('click', function() {
        $('.thank-you-add-to-calendar-dropdown').toggleClass('show');
    });
}